import React, { useState } from 'react';
import { FileText, CheckSquare, Home, Wallet, MessageCircle } from 'lucide-react';

interface FooterNavLayout2Props {
  colors: {
    background: string;
    text: string;
    activeBackground: string;
    activeText: string;
    icon: string;
  };
}

const FooterNavLayout2: React.FC<FooterNavLayout2Props> = ({ colors }) => {
  const navItems = [
    { icon: FileText, label: 'History', active: false },
    { icon: CheckSquare, label: 'All Bids', active: false },
    { icon: Home, label: 'Home', active: true }, // default active
    { icon: Wallet, label: 'Wallet', active: false },
    { icon: MessageCircle, label: 'Chat', active: false }
  ];

  const [activeIndex, setActiveIndex] = useState<number>(2);

  return (
    <div 
      className="flex items-center justify-around py-1 px-3"
      style={{ backgroundColor: colors.background }}
    >
      {navItems.map((item, index) => {
        const Icon = item.icon;
        const isActive = index === activeIndex;
        return (
          <button
            key={index}
            type="button"
            onClick={() => setActiveIndex(index)}
            className="flex flex-col items-center px-2 py-1.5 rounded-md focus:outline-none"
            style={{ backgroundColor: isActive ? colors.activeBackground : 'transparent' }}
          >
            <Icon
              className="w-5 h-5 mb-0.5"
              style={{ color: isActive ? colors.activeText : colors.icon }}
            />
            <span
              className="text-xs font-medium"
              style={{ color: isActive ? colors.activeText : colors.text }}
            >
              {item.label}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default FooterNavLayout2;
